module.exports = __webpack_public_path__ + "img/d8b9930dd774e0d22297bc60c8a2ecc.c4bcda17.jpg";